import React from 'react';
import { Select } from '../../Select';
import { PEPTIDE_OPTIONS } from '../../../constants/peptides';
import type { PeptideName } from '../../../constants/peptides';

interface PeptideSelectProps {
  value: PeptideName;
  onChange: (value: PeptideName) => void;
  error?: string;
}

export const PeptideSelect: React.FC<PeptideSelectProps> = ({ value, onChange, error }) => {
  return (
    <Select
      label="Peptide Name"
      value={value}
      onChange={onChange}
      options={PEPTIDE_OPTIONS}
      error={error}
    />
  );
};